import React, { useState, useEffect } from 'react';
import '../../../../../scenes/FiltersAccordion/components/Section/styles.css';
import FiltersAccordionGroupTag from '../../Group/GroupTag';

const FiltersAccordionTagsSection = props => {
  const {
    groups,
    title,
    selected,
    onSearch,
    sectionKey,
    disabled,
    onPushValue,
    onSelectAll,
    onClearAll,
    onChange,
    toggleFunc,
    toggleIndex,
    toggledIndex,
  } = props;

  const {
    tagType,
  } = groups;
  const [toggled, setToggle] = useState(false);

  useEffect(() => {
    if (toggleIndex === toggledIndex && !toggled) {
      setToggle(true);
    } else if (toggleIndex !== toggledIndex) {
      setToggle(false);
    }
  }, [toggledIndex]);

  const toggleHandler = () => {
    setToggle(!toggled);
    toggleFunc(toggleIndex);
  };

  const handlePush = (groupKey, value) => {
    onPushValue(sectionKey, groupKey, value);
  };

  const handleChange = (groupKey, value) => {
    onChange(sectionKey, groupKey, value);
  };

  const handleSelectAll = groupKey => {
    onSelectAll(sectionKey, groupKey);
  };

  const handleClearAll = groupKey => {
    onClearAll(sectionKey, groupKey);
  };

  const clsCaptionSelected = selected
    ? ' filter-accordion__caption--selected'
    : '';
  const clsCaption =
    (toggled
      ? 'filter-accordion__caption filter-accordion__caption--toggled'
      : 'filter-accordion__caption') + clsCaptionSelected;

  const clsBody = toggled
    ? 'filter-accordion__body filter-accordion__body--open'
    : 'filter-accordion__body';

  const filters = Object.keys(groups).map((key, index) => {
    const {
      title,
      tagTypeId,
      elements,
      type = key === 'tagType' ? 'tag' : 'default',
    } = groups[key];

    const selectedTypes = tagType?.selectedElements || [];
    const visible = type !== 'default' || selectedTypes.includes(tagTypeId) || false;

    if (!visible) {
      return null;
    }

    return (
      <FiltersAccordionGroupTag
        title={title}
        key={index}
        group={key}
        selected={groups[key].selectedElements}
        elements={elements}
        disabled={disabled}
        onChange={handleChange}
        onPushValue={handlePush}
        onSelectAll={handleSelectAll}
        onClearAll={handleClearAll}
      />
    );
  });

  return (
    <div className="filter-accordion">
      <div onClick={toggleHandler} className={clsCaption}>
        {title}
      </div>
      <div className={clsBody}>{filters}</div>
    </div>
  );
};

FiltersAccordionTagsSection.propTypes = {};

export default FiltersAccordionTagsSection;
